import { Grid, Typography } from '@mui/material'

const Error = (props) => {
  const { message, description } = props

  return (
    <Grid container spacing={2} mt="15%">
      <Grid item xs={12}>
        <Typography variant="title" color="primary" align="center" display="block" dangerouslySetInnerHTML={{ __html: message }} />
        {description ? (
          <Typography variant="h5" align="center">
            {description}
          </Typography>
        ) : null}
      </Grid>
    </Grid>
  )
}

export default Error
